<template>
  <direct-chat-block
    icon="link"
    :title="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.WITH_BUSINESS.TITLE')"
    :description="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.WITH_BUSINESS.DESC')"
  >
    <phone-input-v2
      v-model="phone"
      :label="
        $t('INTEGRATION_SETTINGS.DIRECT_CHAT.WITH_BUSINESS.PHONE_NUMBER.LABEL')
      "
      :placeholder="
        $t(
          'INTEGRATION_SETTINGS.DIRECT_CHAT.WITH_BUSINESS.PHONE_NUMBER.PLACEHOLDER'
        )
      "
    />

    <input-v2
      v-model.trim="text"
      :label="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.WITH_BUSINESS.TEXT.LABEL')"
      :placeholder="
        $t('INTEGRATION_SETTINGS.DIRECT_CHAT.WITH_BUSINESS.TEXT.PLACEHOLDER')
      "
    />

    <button-v2
      class="self-start mt-2 !text-base"
      :disabled="!phoneDigits"
      @click="generate"
    >
      {{ $t('INTEGRATION_SETTINGS.DIRECT_CHAT.GENERATE_LINK') }}
    </button-v2>

    <template #result>
      <div>
        <div class="text-sm leading-5 font-semibold text-gray-700 mb-1.5">
          {{ $t('INTEGRATION_SETTINGS.DIRECT_CHAT.GENERATED_LINK') }}
        </div>
        <copy-field-v2
          :value="link"
          :placeholder="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.LINK_PLACEHOLDER')"
          :copy-label="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.COPY')"
        />
      </div>
    </template>
  </direct-chat-block>
</template>

<script>
import DirectChatBlock from './DirectChatBlock.vue';
import { toPhoneDigits } from './helpers';

export default {
  name: 'ChatWithBusiness',
  components: { DirectChatBlock },
  data() {
    return {
      phone: '',
      text: '',
      link: '',
    };
  },
  computed: {
    phoneDigits() {
      return toPhoneDigits(this.phone);
    },
  },
  methods: {
    generate() {
      if (!this.phoneDigits) {
        return;
      }
      this.link = this.text
        ? `https://wa.me/${this.phoneDigits}?text=${encodeURIComponent(
            this.text
          )}`
        : `https://wa.me/${this.phoneDigits}`;
    },
  },
};
</script>
